import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useFinishedExams } from "src/hooks/useExams";

import DefaultExamTable from "./DefaultExamTable";
import { StyledTableCell } from "./DefaultTable";

const formatDate = (date: string) => {
	const newDate = new Date(date);

	return {
		date: newDate.toLocaleDateString(),
		time: newDate.toLocaleTimeString(),
	};
};

interface FinishedExamRow {
	name: string;
	totalQuestions: number;
	correctAnswers: number;
	wrongAnswers: number;
	score: number;
	updatedAt: string;
	[key: string]: unknown;
}

interface FinishedExamsTableProps {
	[key: string]: unknown;
}

function FinishedExamsTable(props: FinishedExamsTableProps) {
	const { t } = useTranslation();

	const headers = [
		{},
		{ key: t("table.exam.finished.headers.name") },
		{
			key: t("table.exam.finished.headers.countOfQuestions"),
			value: "totalQuestions",
		},
		{
			key: t("table.exam.finished.headers.correctAnswers"),
			value: "correctAnswers",
		},
		{
			key: t("table.exam.finished.headers.wrongAnswers"),
			value: "wrongAnswers",
		},
		{ key: t("table.exam.finished.headers.result"), value: "score" },
		{ key: t("table.exam.finished.headers.date"), value: "updatedAt" },
		{ key: t("table.exam.finished.headers.actions") },
	];

	const renderRow = (row: FinishedExamRow) => {
		const { time, date } = formatDate(row.updatedAt);

		return (
			<>
				<StyledTableCell title={row.name} className="text-left size-16-light" data-test-id="exam-name">
					{row.name}
				</StyledTableCell>
				<StyledTableCell className="text-center size-16-light">
					{row.totalQuestions}
				</StyledTableCell>
				<StyledTableCell className="text-center size-16-light text-success">
					{row.correctAnswers}
				</StyledTableCell>
				<StyledTableCell className="text-center size-16-light text-error">
					{row.wrongAnswers}
				</StyledTableCell>
				<StyledTableCell
					className={cx(
						`text-center size-16-light ${row.score > 60 ? "text-success" : "text-error"}`,
					)}
				>
					{`${row.score}%`}
				</StyledTableCell>
				<StyledTableCell
					title={`${date}:${time}`}
					className="text-center size-16-light"
				>
					{date}
				</StyledTableCell>
			</>
		);
	};

	return (
		<DefaultExamTable
			{...props}
			headers={headers}
			renderRow={renderRow}
			getItems={useFinishedExams}
		/>
	);
}

export default FinishedExamsTable;
